module.exports = __webpack_public_path__ + "img/user.c5b9ee22.png";